import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberRangeRif]',
})
export class NumberRangeRifDirective {
  private regex: RegExp = new RegExp(/^-?\d{0,8}-?\d?$/);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
    '-',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value.replace(/-/g, '');
    let next: string = current.concat(event.key);

    if (!next.match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let inputElement = event.target as HTMLInputElement;
    let value = inputElement.value.replace(/-/g, ''); // Remove existing dashes

    if (value.length >= 8) {
      value = value.slice(0, 8) + '-' + value.slice(8);
    }
    // if (value.length > 0) {
    //   value = '-' + value;
    // }

    inputElement.value = value;
  }
}
